import { writable } from "svelte/store";
function isSame(left, right) {
    for (const key in right) {
        const v = left[key];
        const nv = right[key];
        if (v === nv)
            continue;
        if (Array.isArray(v) && Array.isArray(nv) && v.length === nv.length) {
            for (let i = v.length - 1; i >= 0; i--) {
                if (v[i] !== nv[i]) {
                    return false;
                }
            }
            continue;
        }
        return false;
    }
    return true;
}
export function form(v, changes, config) {
    let ready = false;
    let timer = null;
    const store = writable(v);
    const { set } = store;
    let base = { ...v };
    store.set = function (nv) {
        if (!isSame(base, nv)) {
            base = { ...nv };
            set(nv);
        }
    };
    store.update = function (upd) {
        const nv = upd(v);
        if (!isSame(base, nv)) {
            base = { ...nv };
            set(nv);
        }
    };
    store.reset = function (v) {
        ready = false;
        base = {};
        store.set(v);
    };
    store.subscribe(v => {
        if (ready) {
            if (v) {
                if (!config || !config.debounce)
                    changes(v);
                else {
                    clearTimeout(timer);
                    timer = setTimeout(() => changes(v), config.debounce);
                }
            }
        }
        else
            ready = true;
    });
    return store;
}
//# sourceMappingURL=form.js.map